import { EPeriod } from '@/apis/commerce';

/** 默认周期个数；接口未下发 period_count 时与旧数据一致 */
const DEFAULT_PERIOD_COUNT = 1;
/** 季卡：Month × 3 */
const QUARTER_MONTH_COUNT = 3;
/** 3 日：Day × 3 */
const THREE_DAY_COUNT = 3;

/**
 * 前端具名周期（展示 / 后续扩展用，不是线协议枚举）。
 * 未命中映射时仍可按单位天数 × count 展示，不必先加枚举。
 */
export enum EAllPeriod {
    Week = 'Week',
    Month = 'Month',
    Year = 'Year',
    Day = 'Day',
    Quarter = 'Quarter',
    ThreeDay = 'ThreeDay',
}

/** `period:period_count` → 具名周期；遗留 Quarter/ThreeDay 的 count 在查表前已归一为 1 */
export const ALL_PERIOD_MAP: Readonly<Record<string, EAllPeriod>> = {
    [`${EPeriod.Week}:${DEFAULT_PERIOD_COUNT}`]: EAllPeriod.Week,
    [`${EPeriod.Month}:${DEFAULT_PERIOD_COUNT}`]: EAllPeriod.Month,
    [`${EPeriod.Year}:${DEFAULT_PERIOD_COUNT}`]: EAllPeriod.Year,
    [`${EPeriod.Day}:${DEFAULT_PERIOD_COUNT}`]: EAllPeriod.Day,
    [`${EPeriod.Month}:${QUARTER_MONTH_COUNT}`]: EAllPeriod.Quarter,
    [`${EPeriod.Day}:${THREE_DAY_COUNT}`]: EAllPeriod.ThreeDay,
    [`${EPeriod.Quarter}:${DEFAULT_PERIOD_COUNT}`]: EAllPeriod.Quarter,
    [`${EPeriod.ThreeDay}:${DEFAULT_PERIOD_COUNT}`]: EAllPeriod.ThreeDay,
};

/** 拼 AllPeriod 映射 key */
export function toAllPeriodKey(period: number, count: number): string {
    return `${period}:${count}`;
}

/** 存量复合周期：不再乘 period_count，一律按 1 */
export function isLegacyCompositePeriod(period: number): boolean {
    return period === EPeriod.Quarter || period === EPeriod.ThreeDay;
}

/**
 * 归一 period_count：缺省为 1；Quarter/ThreeDay 强制 1；非法（非 >=1 整数）返回 undefined
 * @param period Period 枚举值
 * @param periodCount 接口 period_count，可缺省
 */
export function resolvePeriodCount(period: number, periodCount?: number): number | undefined {
    if (isLegacyCompositePeriod(period)) {
        return DEFAULT_PERIOD_COUNT;
    }
    if (periodCount == null) {
        return DEFAULT_PERIOD_COUNT;
    }
    if (!Number.isSafeInteger(periodCount) || periodCount < DEFAULT_PERIOD_COUNT) {
        return undefined;
    }
    return periodCount;
}

/**
 * 将 period + period_count 转成具名 AllPeriod；未登记组合返回 undefined
 * @param period Period 枚举值
 * @param periodCount 接口 period_count，可缺省
 */
export function resolveAllPeriod(period?: number, periodCount?: number): EAllPeriod | undefined {
    if (period == null) {
        return undefined;
    }
    const count = resolvePeriodCount(period, periodCount);
    if (count == null) {
        return undefined;
    }
    return ALL_PERIOD_MAP[toAllPeriodKey(period, count)];
}
